import { User } from 'oidc-client-ts'

export function isSysAdmin(user: User | null): boolean {
  if (!user?.profile) return false
  const roles = user.profile.roles as string | string[] | undefined

  if (Array.isArray(roles)) {
    return roles.includes('sysadmin')
  }
  return roles === 'sysadmin'
}

export function isWorkspaceAdmin(user: User | null): boolean {
  if (!user?.profile) return false
  const roles = user.profile.roles as string | string[] | undefined

  if (Array.isArray(roles)) {
    return roles.includes('workspace_admin')
  }
  return roles === 'workspace_admin'
}

export function isWorkspaceApprover(user: User | null): boolean {
  if (!user?.profile) return false
  const roles = user.profile.roles as string | string[] | undefined

  if (Array.isArray(roles)) {
    return roles.includes('workspace_approver')
  }
  return roles === 'workspace_approver'
}

export function isWorkspaceUser(user: User | null): boolean {
  if (!user?.profile) return false
  const roles = user.profile.roles as string | string[] | undefined

  if (Array.isArray(roles)) {
    return roles.includes('workspace_user')
  }
  return roles === 'workspace_user'
}

export function isRequesterSales(user: User | null): boolean {
  if (!user?.profile) return false
  const roles = user.profile.roles as string | string[] | undefined

  if (Array.isArray(roles)) {
    return roles.includes('requester_sales')
  }
  return roles === 'requester_sales'
}

export function isRequesterConsultant(user: User | null): boolean {
  if (!user?.profile) return false
  const roles = user.profile.roles as string | string[] | undefined

  if (Array.isArray(roles)) {
    return roles.includes('requester_consultant')
  }
  return roles === 'requester_consultant'
}

export function isRequesterFinance(user: User | null): boolean {
  if (!user?.profile) return false
  const roles = user.profile.roles as string | string[] | undefined

  if (Array.isArray(roles)) {
    return roles.includes('requester_finance')
  }
  return roles === 'requester_finance'
}

export function isBillingAdmin(user: User | null): boolean {
  if (!user?.profile) return false
  const roles = user.profile.roles as string | string[] | undefined

  if (Array.isArray(roles)) {
    return roles.includes('billing_admin')
  }
  return roles === 'billing_admin'
}

export function isBillingUser(user: User | null): boolean {
  if (!user?.profile) return false
  const roles = user.profile.roles as string | string[] | undefined

  if (Array.isArray(roles)) {
    return roles.includes('billing_user')
  }
  return roles === 'billing_user'
}

export function hasBillingAccess(user: User | null): boolean {
  return isBillingAdmin(user) || isBillingUser(user)
}

export function isAnyRequester(user: User | null): boolean {
  return isRequesterSales(user) || isRequesterConsultant(user) || isRequesterFinance(user)
}

export function canRequestTermination(user: User | null): boolean {
  return isSysAdmin(user) || isRequesterFinance(user)
}

export function canViewTerminations(user: User | null): boolean {
  return canRequestTermination(user) || isWorkspaceApprover(user) || isWorkspaceAdmin(user)
}

export function getAllowedWorkspaceTypes(user: User | null): Set<'new' | 'demo' | 'trial' | 'uat'> {
  const out = new Set<'new' | 'demo' | 'trial' | 'uat'>()
  if (isSysAdmin(user)) {
    out.add('new')
    out.add('demo')
    out.add('trial')
    out.add('uat')
    return out
  }
  if (isRequesterSales(user)) {
    out.add('demo')
    out.add('trial')
  }
  if (isRequesterConsultant(user)) {
    out.add('uat')
  }
  if (isRequesterFinance(user)) {
    out.add('new')
  }
  return out
}
